import { createApp } from 'vue';

import Search from '../components/general/search.vue';
import Filters from '../components/general/filters.vue';
import CommunityName from '../components/home/community-name.vue';
import CommunityBackground from '../components/home/community-background.vue';

const headerElement = document.getElementById('page-header');

if (headerElement) {
	const headerApp = createApp({
		components: {
			CommunityBackground,
			CommunityName,
			Filters,
			Search,
		},
		data() {
			return {
				communities: [],
				communityIndex: 0,
			};
		},
		computed: {
			communityName() {
				const { communityIndex, communities } = this;

				if (!communities || communities.length === 0) return false;

				const community = communities[communityIndex];

				return community ? community.title : false;
			},
		},
		mounted() {
			this.communities = Array.isArray(window.sliderCommunities) ? window.sliderCommunities : [];

			if (this.communities.length <= 1) return;

			setInterval(() => {
				if (this.communityIndex === this.communities.length - 1) {
					this.communityIndex = 0;
				} else {
					this.communityIndex++;
				}
			}, 5000);
		},
	});

	headerApp.config.compilerOptions.whitespace = 'preserve';
	headerApp.mount(headerElement);
}

const footerElement = document.getElementById('footer-cta');

if (footerElement) {
	const footerApp = createApp({
		components: {
			Filters,
			Search,
		},
	});

	footerApp.config.compilerOptions.whitespace = 'preserve';
	footerApp.mount(footerElement);
}
